import {UPDATE_MONEY_BOX} from './actions';

export function moneyBox(state: MoneyBoxState, {type, payload}: Action): MoneyBoxState {
  switch (type) {
    case UPDATE_MONEY_BOX:
      return {...(payload as MoneyBoxState)};

    default:
      return state;
  }
}
